module.exports = __webpack_public_path__ + "static/media/house-atl.625cbd58.svg";